export default __webpack_public_path__ + "static/media/illust-ui.5ad85d88.svg";